import script from "./NoteList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteList.vue?vue&type=script&setup=true&lang=js"

import "./NoteList.vue?vue&type=style&index=0&id=97d2a4da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d2a4da"]])

export default __exports__